// apps/client/src/assets/builders/fruit.ts — one rounded shape per FruitEntry.fruit (dropped fruit, tree fruit, icons)
import * as THREE from 'three';
import { getItem, type FruitEntry } from '@whiskerton/content';
import { toyMaterial } from '../../characters/doll';
import type { CodeBuilder } from '../service';
const LEAF = '#5DAE62', STEM = '#6B4F2E';
export const builder: CodeBuilder = {
  id: 'fruit',
  build(p) {
    const e = getItem(String(p.catalogId)) as FruitEntry;
    const g = new THREE.Group();
    const stem = (y: number) => { const s = new THREE.Mesh(new THREE.CylinderGeometry(0.008, 0.01, 0.07, 6), toyMaterial(STEM)); s.position.y = y; return s; };
    const leaf = (y: number) => { const l = new THREE.Mesh(new THREE.SphereGeometry(0.04, 8, 6).scale(1.6, 0.3, 0.8), toyMaterial(LEAF)); l.position.set(0.04, y, 0); return l; };
    if (e.fruit === 'cherry') {
      for (const s of [-1, 1]) { const c = new THREE.Mesh(new THREE.SphereGeometry(0.07, 14, 10), toyMaterial('#B0243A')); c.position.set(s * 0.06, 0.07, 0); g.add(c); }
      g.add(stem(0.16), leaf(0.2));
    } else if (e.fruit === 'pear') {
      const pts = [0, 0.09, 0.13, 0.12, 0.08, 0.06, 0.05, 0].map((r, i) => new THREE.Vector2(r, i * 0.04));
      g.add(new THREE.Mesh(new THREE.LatheGeometry(pts, 16), toyMaterial('#C9D46A')), stem(0.31), leaf(0.31));
    } else {
      const look = { apple: ['#D9473B', 0.14, 0.9], orange: ['#F39A2B', 0.15, 1], peach: ['#F6A57E', 0.145, 0.95] }[e.fruit] as [string, number, number];
      const ball = new THREE.Mesh(new THREE.SphereGeometry(look[1], 18, 14), toyMaterial(look[0])); ball.scale.y = look[2]; ball.position.y = look[1];
      g.add(ball, stem(look[1] * 2), leaf(look[1] * 2));
    }
    return g;
  },
};
